<template>
<div :class="bem()">
    <img src="https://st-gdx.dancf.com/gaodingx/1868/configs/system/20201030-141146-574b.svg" alt="">
    <img :class="bem('title')" src="https://st-gdx.dancf.com/gaodingx/1868/configs/system/20201030-141401-b343.svg" alt="">
    <div :class="bem('right')" v-for="(right, index) in rights" :key="index">
        <img :class="bem('right-icon')" src="https://st-gdx.dancf.com/gaodingx/1868/configs/system/20201030-142054-37fe.svg" alt="">
        <span :class="bem('right-content')">{{right}}</span>
    </div>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
import bemMixin from './bem';
export default {
  name: 'g-login-modal-left-content',
  mixins: [bemMixin],
  computed: {
    rights: function rights() {
      return ['30W+精选模板 每日更新', '海量正版素材 随意创作', '智能抠图 只需3秒', '商用授权 使用安心', '云端储存 随时修改'];
    }
  }
};
</script>
<style scoped>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-login-modal-left-content {
  width: 302px;
  height: 480px;
  padding: 58px 0 0 24px;
  background-image: url('https://st-gdx.dancf.com/gaodingx/1868/configs/system/20201030-140508-1723.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
}
.g-login-modal-left-content__title {
  margin-left: -16px;
  margin-top: 20px;
  margin-bottom: 42px;
}
.g-login-modal-left-content__right {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 14px;
  color: #F0F6FF;
}
.g-login-modal-left-content__right-icon {
  margin-right: 12px;
}
.g-login-modal-left-content__right-content {
  opacity: 0.9;
}

</style>
